/* AF Nutrition — tema Shopify. Vanilla JS: cart drawer, add-to-cart, hero slider, nav, galeria. */
(function () {
  "use strict";
  const $ = (s, r) => (r || document).querySelector(s);
  const $$ = (s, r) => Array.from((r || document).querySelectorAll(s));
  let maybeShowLeadModal = function () {};
  let onDrawerClosed = function () {};

  const money = (cents) =>
    (cents / 100).toLocaleString("pt-BR", { style: "currency", currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || "BRL" });

  /* ---------- Cart ---------- */
  const drawer = $("[data-cart-drawer]");
  const panel = $("[data-cart-panel]");
  const overlay = $("[data-cart-overlay]");

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.remove("hidden");
    drawer.classList.add("pointer-events-auto");
    requestAnimationFrame(() => {
      panel && panel.classList.remove("translate-x-full");
      overlay && overlay.classList.remove("opacity-0");
    });
    document.body.style.overflow = "hidden";
  }
  function closeDrawer() {
    if (!drawer) return;
    panel && panel.classList.add("translate-x-full");
    overlay && overlay.classList.add("opacity-0");
    document.body.style.overflow = "";
    setTimeout(() => { drawer.classList.add("hidden"); drawer.classList.remove("pointer-events-auto"); onDrawerClosed(); }, 300);
  }

  function renderCart(cart) {
    $$("[data-cart-count]").forEach((el) => {
      el.textContent = cart.item_count;
      el.classList.toggle("hidden", cart.item_count === 0);
    });
    const list = $("[data-cart-items]");
    const empty = $("[data-cart-empty]");
    const footer = $("[data-cart-footer]");
    const tmpl = $("[data-cart-item-template]");
    if (!list || !tmpl) return;
    list.innerHTML = "";
    if (cart.item_count === 0) {
      empty && (empty.style.display = "");
      footer && (footer.hidden = true);
      updateFreeShipBar(cart);
      return;
    }
    empty && (empty.style.display = "none");
    footer && (footer.hidden = false);
    cart.items.forEach((item) => {
      const node = tmpl.content.cloneNode(true);
      const link = $("[data-line-img-link]", node);
      const img = $("[data-line-img]", node);
      const title = $("[data-line-title]", node);
      const variant = $("[data-line-variant]", node);
      const qty = $("[data-line-qty]", node);
      const price = $("[data-line-price]", node);
      link.href = item.url;
      if (item.image) { img.src = item.image.replace(/(\.[a-z]+)(\?|$)/i, "_160x$1$2"); }
      img.alt = item.product_title;
      title.textContent = item.product_title;
      title.href = item.url;
      variant.textContent = (item.variant_title && !/default/i.test(item.variant_title)) ? item.variant_title : "";
      qty.textContent = item.quantity;
      price.textContent = money(item.final_line_price);
      $("[data-line-minus]", node).addEventListener("click", () => changeLine(item.key, item.quantity - 1));
      $("[data-line-plus]", node).addEventListener("click", () => changeLine(item.key, item.quantity + 1));
      list.appendChild(node);
    });
    const sub = $("[data-cart-subtotal]");
    sub && (sub.textContent = money(cart.total_price));
    updateFreeShipBar(cart);
  }

  function updateFreeShipBar(cart) {
    if (!drawer) return;
    const wrap = drawer.querySelector("[data-fs-wrap]");
    if (wrap) wrap.style.display = "";
    const bar = drawer.querySelector("[data-fs-bar]");
    if (!bar) return;
    const threshold = parseInt(bar.getAttribute("data-fs-threshold"), 10) || 19900;
    const remaining = threshold - cart.total_price;
    const pct = Math.min(100, Math.round((cart.total_price / threshold) * 100));
    const fill = bar.querySelector("[data-fs-fill]");
    const msg = bar.querySelector("[data-fs-msg]");
    if (fill) fill.style.width = pct + "%";
    if (msg) {
      /* Mesmas frases do snippet frete-gratis-texto.liquid (aprovadas 2026-09-03); a região vem do data-attribute. */
      const reg = (bar.getAttribute("data-fs-region") || "").trim();
      msg.innerHTML = remaining > 0
        ? 'Faltam <span class="font-extrabold text-ink">' + money(remaining) + '</span> para o <span class="font-bold text-green-700">frete grátis</span>' + (reg ? ' no ' + reg : '')
        : '🎉 <span class="font-extrabold text-green-700">Frete grátis' + (reg ? ' para ' + reg : '') + '!</span>';
    }
  }

  function refreshCart(open) {
    return fetch("/cart.js", { headers: { "Content-Type": "application/json" } })
      .then((r) => r.json())
      .then((cart) => { renderCart(cart); if (open) openDrawer(); return cart; });
  }

  function addToCart(id, qty) {
    return fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: id, quantity: qty || 1 }),
    })
      .then((r) => r.json())
      .then(() => refreshCart(true))
      .catch(() => { window.location.href = "/cart"; });
  }

  function changeLine(key, quantity) {
    fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: key, quantity: Math.max(0, quantity) }),
    })
      .then((r) => r.json())
      .then((cart) => renderCart(cart));
  }

  document.addEventListener("click", (e) => {
    const add = e.target.closest("[data-add-to-cart]");
    if (add) { e.preventDefault(); const id = add.getAttribute("data-variant-id"); if (id) { add.disabled = true; addToCart(id).finally(() => (add.disabled = false)); } return; }
    if (e.target.closest("[data-cart-toggle]")) { e.preventDefault(); refreshCart(true); return; }
    if (e.target.closest("[data-cart-close]") || e.target === overlay) { closeDrawer(); return; }
  });
  document.addEventListener("keydown", (e) => { if (e.key === "Escape") closeDrawer(); });

  /* product form add */
  const pform = $("[data-product-form]");
  if (pform) {
    pform.addEventListener("submit", (e) => {
      e.preventDefault();
      const id = ($("[data-variant-input]", pform) || {}).value;
      const btn = $("[data-atc-submit]", pform);
      if (!id) return;
      btn && (btn.disabled = true);
      addToCart(id, 1).finally(() => btn && (btn.disabled = false));
    });
    // variant selection
    const variants = (() => { try { return JSON.parse($("[data-variants]").textContent); } catch (_) { return []; } })();
    const optionEls = $$("[data-option]", pform);
    if (optionEls.length) {
      pform.addEventListener("change", () => {
        const chosen = [];
        const groups = {};
        optionEls.forEach((el) => { if (el.checked) groups[el.name] = el.value; });
        Object.keys(groups).sort().forEach((k) => chosen.push(groups[k]));
        const match = variants.find((v) => JSON.stringify(v.options) === JSON.stringify(chosen)) || variants.find((v) => v.available);
        if (match) { $("[data-variant-input]", pform).value = match.id; }
      });
    }
  }

  /* ---------- Mobile nav ---------- */
  const navToggle = $("[data-menu-toggle]");
  const mobileNav = $("[data-mobile-nav]");
  navToggle && navToggle.addEventListener("click", () => mobileNav && mobileNav.classList.toggle("hidden"));

  /* ---------- Product gallery ---------- */
  const galleryThumbs = $$("[data-product-thumb]");
  const galleryActive = ["border-gold-500", "ring-1", "ring-gold-400"];
  const galleryInactive = ["border-ink/8"];
  galleryThumbs.forEach((btn) =>
    btn.addEventListener("click", () => {
      const main = $("[data-product-main]");
      if (main) main.src = btn.getAttribute("data-product-thumb");
      galleryThumbs.forEach((t) => {
        t.classList.remove(...galleryActive);
        t.classList.add(...galleryInactive);
      });
      btn.classList.remove(...galleryInactive);
      btn.classList.add(...galleryActive);
    })
  );

  /* ---------- Galeria: troca automática + setas prev/próxima na foto principal ---------- */
  if (galleryThumbs.length > 1) {
    let gIdx = 0;
    const scrollThumb = () => {
      /* Rola SÓ a tira horizontal de thumbs — nunca o viewport. scrollIntoView aqui puxava a
         página inteira de volta pra galeria a cada tick do autoplay quando o usuário estava
         em outra parte da página (ex.: rodapé). */
      const t = galleryThumbs[gIdx];
      const strip = t && t.parentElement;
      if (!t || !strip) return;
      const left = strip.scrollLeft + (t.getBoundingClientRect().left - strip.getBoundingClientRect().left) - (strip.clientWidth - t.clientWidth) / 2;
      strip.scrollTo({ left: Math.max(0, left), behavior: "smooth" });
    };
    const goTo = (i) => {
      gIdx = (i + galleryThumbs.length) % galleryThumbs.length;
      galleryThumbs[gIdx].click();
      scrollThumb();
    };
    let gTimer = setInterval(() => goTo(gIdx + 1), 4000);
    const resetTimer = () => { clearInterval(gTimer); gTimer = setInterval(() => goTo(gIdx + 1), 4000); };
    galleryThumbs.forEach((btn, i) =>
      btn.addEventListener("click", (e) => {
        if (e.isTrusted) { gIdx = i; resetTimer(); scrollThumb(); }
      })
    );
    // setas prev/próxima sobre a foto grande (trocam a imagem principal; a tira acompanha)
    const mImg = $("[data-product-main]");
    const mWrap = mImg && mImg.closest(".relative");
    if (mWrap) {
      if (!document.getElementById("af-mainnav-css")) {
        const st = document.createElement("style");
        st.id = "af-mainnav-css";
        st.textContent = ".af-mainnav{position:absolute;top:50%;transform:translateY(-50%);z-index:5;display:flex;align-items:center;justify-content:center;width:38px;height:38px;border-radius:9999px;background:rgba(255,255,255,.92);color:#0c0c0e;border:1px solid rgba(12,12,14,.1);box-shadow:0 2px 10px rgba(0,0,0,.14);cursor:pointer;padding:0;transition:background .15s;}.af-mainnav:hover{background:#fff;}.af-mainnav.l{left:10px;}.af-mainnav.r{right:10px;}";
        document.head.appendChild(st);
      }
      const mk = (c, l, p) => {
        const b = document.createElement("button");
        b.type = "button"; b.className = "af-mainnav " + c; b.setAttribute("aria-label", l);
        b.innerHTML = '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="' + p + '"/></svg>';
        return b;
      };
      const bL = mk("l", "Imagem anterior", "m15 6-6 6 6 6"), bR = mk("r", "Próxima imagem", "m9 6 6 6-6 6");
      bL.addEventListener("click", () => { goTo(gIdx - 1); resetTimer(); });
      bR.addEventListener("click", () => { goTo(gIdx + 1); resetTimer(); });
      mWrap.appendChild(bL); mWrap.appendChild(bR);
    }
  }

  /* ---------- Filtros da coleção: só um <details> aberto por vez ---------- */
  const filterDetails = $$("[data-filter-details]");
  if (filterDetails.length) {
    filterDetails.forEach((d) =>
      d.addEventListener("toggle", () => {
        if (d.open) filterDetails.forEach((o) => { if (o !== d) o.open = false; });
      })
    );
    document.addEventListener("click", (e) => {
      filterDetails.forEach((d) => {
        if (d.open && !d.contains(e.target)) d.open = false;
      });
    });
  }

  /* ---------- Carrossel de vitrine (setas) ---------- */
  $$("[data-car-track]").forEach((track) => {
    const wrap = track.parentElement;
    const prev = wrap.querySelector("[data-car-prev]");
    const next = wrap.querySelector("[data-car-next]");
    const step = () => Math.max(240, Math.round(track.clientWidth * 0.8));
    prev && prev.addEventListener("click", () => track.scrollBy({ left: -step(), behavior: "smooth" }));
    next && next.addEventListener("click", () => track.scrollBy({ left: step(), behavior: "smooth" }));
  });

  /* ---------- Hero slider (dissolve/crossfade) ---------- */
  const hero = $("[data-hero]");
  if (hero) {
    const track = $("[data-hero-track]", hero);
    const slides = $$("[data-hero-slide]", hero);
    const dots = $$("[data-hero-dot]", hero);
    let i = 0, timer = null;
    const n = slides.length;
    const autoplay = parseInt(hero.getAttribute("data-autoplay") || "7", 10);
    const FADE_MS = 700;

    function updateDots() {
      dots.forEach((d, k) => {
        d.classList.toggle("w-7", k === i); d.classList.toggle("bg-gold-400", k === i);
        d.classList.toggle("w-2", k !== i); d.classList.toggle("bg-white/40", k !== i);
      });
    }
    function settle() {
      slides.forEach((s, k) => {
        const active = k === i;
        s.style.transition = "none";
        s.style.opacity = active ? "1" : "0";
        s.style.zIndex = active ? "1" : "0";
        s.style.pointerEvents = active ? "auto" : "none";
      });
    }
    function go(idx) {
      const next = ((idx % n) + n) % n;
      if (next === i) return;
      const to = slides[next];
      to.style.transition = "none";
      to.style.zIndex = "2";
      to.style.pointerEvents = "auto";
      to.style.opacity = "0";
      void to.offsetHeight;
      to.style.transition = "opacity " + FADE_MS + "ms ease-out";
      to.style.opacity = "1";
      i = next;
      updateDots();
      clearTimeout(go._t);
      go._t = setTimeout(settle, FADE_MS + 20);
    }
    function start() { if (n > 1 && autoplay > 0) timer = setInterval(() => go(i + 1), autoplay * 1000); }
    function stop() { clearInterval(timer); }
    $("[data-hero-prev]", hero) && $("[data-hero-prev]", hero).addEventListener("click", () => { go(i - 1); stop(); start(); });
    $("[data-hero-next]", hero) && $("[data-hero-next]", hero).addEventListener("click", () => { go(i + 1); stop(); start(); });
    dots.forEach((d, k) => d.addEventListener("click", () => { go(k); stop(); start(); }));

    /* swipe / arrastar no touch — dissolve acompanha o dedo em tempo real */
    if (n > 1) {
      let dragging = false, startX = 0, startY = 0, axisLocked = "", widthPx = 0, dragDir = 0, dragTarget = null, dragTargetIdx = -1;
      track.addEventListener("touchstart", (e) => {
        dragging = true; axisLocked = ""; dragDir = 0; dragTarget = null;
        startX = e.touches[0].clientX; startY = e.touches[0].clientY;
        widthPx = hero.getBoundingClientRect().width;
        stop();
      }, { passive: true });
      track.addEventListener("touchmove", (e) => {
        if (!dragging) return;
        const dx = e.touches[0].clientX - startX;
        const dy = e.touches[0].clientY - startY;
        if (!axisLocked) axisLocked = Math.abs(dx) > Math.abs(dy) ? "x" : "y";
        if (axisLocked !== "x") return;
        const dir = dx < 0 ? 1 : -1;
        if (dir !== dragDir) {
          if (dragTarget) {
            dragTarget.style.transition = "none";
            dragTarget.style.opacity = "0";
            dragTarget.style.pointerEvents = "none";
            dragTarget.style.zIndex = "0";
          }
          dragDir = dir;
          dragTargetIdx = ((i + dir) % n + n) % n;
          dragTarget = slides[dragTargetIdx];
          dragTarget.style.transition = "none";
          dragTarget.style.zIndex = "2";
          dragTarget.style.pointerEvents = "none";
        }
        const amount = Math.min(1, Math.abs(dx) / widthPx);
        dragTarget.style.opacity = String(amount);
      }, { passive: true });
      function onDragEnd() {
        if (!dragging) return;
        dragging = false;
        if (axisLocked === "x" && dragTarget) {
          const amount = parseFloat(dragTarget.style.opacity || "0");
          if (amount >= 0.28) {
            const targetIdx = dragTargetIdx;
            dragTarget.style.transition = "opacity 220ms ease-out";
            dragTarget.style.opacity = "1";
            i = targetIdx;
            updateDots();
            clearTimeout(go._t);
            go._t = setTimeout(settle, 240);
          } else {
            const cancelTarget = dragTarget;
            cancelTarget.style.transition = "opacity 220ms ease-out";
            cancelTarget.style.opacity = "0";
            setTimeout(() => { cancelTarget.style.pointerEvents = "none"; cancelTarget.style.zIndex = "0"; }, 220);
          }
        }
        dragTarget = null; dragDir = 0;
        start();
      }
      track.addEventListener("touchend", onDragEnd);
      track.addEventListener("touchcancel", onDragEnd);
    }

    updateDots();
    start();
  }

  /* ---------- Lead capture (10% OFF) — só na home, timer OU 50% de scroll, nunca com o drawer aberto ----------
     Submit é form nativo do Shopify ({% form 'contact' %}, ver snippet) — a loja
     tem hCaptcha no formulário de contato, então NÃO dá pra interceptar via fetch
     (retorna 400 "Missing CAPTCHA token"). O submit recarrega a página; a etapa do
     cupom reabre sozinha via form.posted_successfully? (atributo data-lead-auto-open). */
  const leadModal = $("[data-lead-modal]");
  const LEAD_STORAGE_KEY = "af_lead_seen";

  if (leadModal) {
    const overlay = $("[data-lead-overlay]", leadModal);
    const panel = $("[data-lead-panel]", leadModal);
    const stepForm = $('[data-lead-step="form"]', leadModal);
    const stepCoupon = $('[data-lead-step="coupon"]', leadModal);
    const submitBtn = $("[data-lead-submit]", leadModal);
    const submitLabel = $("[data-lead-submit-label]", leadModal);
    const copyBtn = $("[data-lead-copy]", leadModal);
    const codeEl = $("[data-lead-coupon-code]", leadModal);
    const copiedMsg = $("[data-lead-copied-msg]", leadModal);
    const form = document.getElementById("af-lead-capture-form");
    const daySel = $("[data-lead-day]", leadModal);
    const monthSel = $("[data-lead-month]", leadModal);
    const yearSel = $("[data-lead-year]", leadModal);
    const birthdayHidden = $("[data-lead-birthday-hidden]", leadModal);

    function syncBirthday() {
      if (!birthdayHidden) return;
      const bday = [daySel && daySel.value, monthSel && monthSel.value, yearSel && yearSel.value].filter(Boolean).join("/");
      birthdayHidden.value = bday ? "aniversario-" + bday : "";
    }
    [daySel, monthSel, yearSel].forEach((el) => el && el.addEventListener("change", syncBirthday));

    function openLeadModal() {
      leadModal.classList.remove("hidden", "pointer-events-none");
      requestAnimationFrame(() => {
        overlay && overlay.classList.remove("opacity-0");
        panel && panel.classList.remove("opacity-0", "scale-95");
      });
      document.body.style.overflow = "hidden";
    }
    function closeLeadModal() {
      overlay && overlay.classList.add("opacity-0");
      panel && panel.classList.add("opacity-0", "scale-95");
      document.body.style.overflow = "";
      setTimeout(() => leadModal.classList.add("hidden", "pointer-events-none"), 300);
      try { localStorage.setItem(LEAD_STORAGE_KEY, "1"); } catch (_) {}
    }
    /* Gatilhos (decisão do operador 2026-09-03): página home (request.page_type == 'index') E
       (20 s desde o carregamento OU 50% da página rolada), o que vier primeiro. Se o drawer do
       carrinho estiver aberto no momento do gatilho, espera ele fechar. Nunca no add-to-cart,
       nunca em produto/carrinho/checkout. 1 vez por navegador (af_lead_seen). */
    const leadPage = leadModal.getAttribute("data-lead-page") || "";
    const leadDelay = parseInt(leadModal.getAttribute("data-lead-delay"), 10) || 20000;
    const leadScrollPct = parseInt(leadModal.getAttribute("data-lead-scroll"), 10) || 50;
    let leadOpened = false, leadPending = false;
    function leadSeen() { try { return !!localStorage.getItem(LEAD_STORAGE_KEY); } catch (_) { return false; } }
    function drawerIsOpen() { return !!(drawer && !drawer.classList.contains("hidden")); }
    function tryOpenLead() {
      if (leadOpened || leadSeen() || leadPage !== "index") return;
      if (drawerIsOpen()) { leadPending = true; return; }
      leadOpened = true;
      openLeadModal();
    }
    onDrawerClosed = function () { if (leadPending) { leadPending = false; tryOpenLead(); } };
    maybeShowLeadModal = function () {}; /* mantido por compatibilidade: add-to-cart NÃO abre mais o pop-up */
    if (leadPage === "index" && !leadSeen()) {
      setTimeout(tryOpenLead, leadDelay);
      const onScroll = () => {
        const max = document.documentElement.scrollHeight - window.innerHeight;
        if (max <= 0) return;
        if ((window.scrollY / max) * 100 >= leadScrollPct) { window.removeEventListener("scroll", onScroll); tryOpenLead(); }
      };
      window.addEventListener("scroll", onScroll, { passive: true });
    }

    leadModal.addEventListener("click", (e) => {
      if (e.target.closest("[data-lead-close]") || e.target === overlay) closeLeadModal();
    });
    document.addEventListener("keydown", (e) => { if (e.key === "Escape" && !leadModal.classList.contains("hidden")) closeLeadModal(); });

    form && form.addEventListener("submit", () => {
      submitBtn.disabled = true;
      submitLabel.textContent = "Enviando...";
    });

    copyBtn && copyBtn.addEventListener("click", () => {
      const code = (codeEl.textContent || "").trim();
      const done = () => {
        copiedMsg.style.visibility = "visible";
        setTimeout(() => { copiedMsg.style.visibility = "hidden"; }, 1800);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(done).catch(done);
      } else {
        done();
      }
    });

    /* Normaliza scrollRestoration em toda pagina (auto = default do navegador). Tambem cura
       abas que ficaram travadas em 'manual' por uma versao anterior deste fix. */
    if ("scrollRestoration" in history) history.scrollRestoration = "auto";
    const autoOpen = leadModal.getAttribute("data-lead-auto-open");
    if (autoOpen) {
      /* Fix: o form nativo (form 'customer') recarrega a pagina com a ancora #af-lead-capture-form
         e o navegador rola ate o form (perto do rodape). Remove a ancora da URL e volta ao topo. */
      if (location.hash) { try { history.replaceState(null, "", location.pathname + location.search); } catch (_) {} }
      window.scrollTo(0, 0);
    }
    if (autoOpen === "coupon") {
      stepForm.classList.add("hidden");
      stepCoupon.classList.remove("hidden");
      openLeadModal();
      try { localStorage.setItem(LEAD_STORAGE_KEY, "1"); } catch (_) {}
    } else if (autoOpen === "form-error") {
      openLeadModal();
    }
  }

  /* ---------- Banner de consentimento (Shopify) x drawer do carrinho ----------
     O banner #shopify-pc__banner é fixed bottom com z-index 2000000 e cobria o "Finalizar compra"
     do drawer no mobile. Aqui só MEDIMOS a altura do banner enquanto ele está visível e gravamos
     --pc-banner-h no <html>; o CSS do drawer usa a variável como padding inferior do painel.
     Nada do banner é removido, escondido ou pré-aceito. */
  (function () {
    const root = document.documentElement;
    let observed = null;
    function measure() {
      const b = document.getElementById("shopify-pc__banner");
      let h = 0;
      if (b) {
        const cs = getComputedStyle(b);
        const r = b.getBoundingClientRect();
        if (cs.display !== "none" && cs.visibility !== "hidden" && cs.position === "fixed" && r.height > 0 && r.bottom > window.innerHeight - 4) h = Math.round(r.height);
        if (b !== observed && window.MutationObserver) {
          observed = b;
          new MutationObserver(measure).observe(b, { attributes: true, attributeFilter: ["style", "class", "hidden"] });
          if (window.ResizeObserver) new ResizeObserver(measure).observe(b);
        }
      }
      root.style.setProperty("--pc-banner-h", h + "px");
      root.classList.toggle("pc-banner-on", h > 0);
      root.classList.add("pc-measured");
    }
    measure();
    [300, 1000, 2500, 5000].forEach((t) => setTimeout(measure, t));
    window.addEventListener("resize", measure);
    if (window.MutationObserver) new MutationObserver(() => { if (!observed && document.getElementById("shopify-pc__banner")) measure(); }).observe(document.body, { childList: true });
  })();

  /* ---------- Busca preditiva (expande do ícone, resultados ao vivo) ---------- */
  (function () {
    const toggle = $("[data-search-toggle]");
    const panel = $("[data-search-panel]");
    if (!toggle || !panel) return;
    const input = $("[data-search-input]", panel);
    const results = $("[data-search-results]", panel);
    const closeBtn = $("[data-search-close]", panel);
    let timer;

    const fmtPrice = (p) => "R$ " + Number(p).toFixed(2).replace(".", ",");
    const clearResults = () => { results.classList.add("hidden"); results.innerHTML = ""; };

    function openPanel() {
      panel.classList.remove("hidden");
      toggle.setAttribute("aria-expanded", "true");
      setTimeout(() => input && input.focus(), 30);
    }
    function closePanel() {
      panel.classList.add("hidden");
      toggle.setAttribute("aria-expanded", "false");
      clearResults();
    }

    toggle.addEventListener("click", (e) => {
      e.preventDefault();
      panel.classList.contains("hidden") ? openPanel() : closePanel();
    });
    closeBtn && closeBtn.addEventListener("click", closePanel);
    document.addEventListener("keydown", (e) => { if (e.key === "Escape" && !panel.classList.contains("hidden")) closePanel(); });
    document.addEventListener("click", (e) => {
      if (!panel.classList.contains("hidden") && !panel.contains(e.target) && !toggle.contains(e.target)) closePanel();
    });

    input && input.addEventListener("input", () => {
      const q = input.value.trim();
      clearTimeout(timer);
      if (q.length < 2) { clearResults(); return; }
      timer = setTimeout(() => {
        const url = "/search/suggest.json?q=" + encodeURIComponent(q) +
          "&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last";
        fetch(url, { headers: { Accept: "application/json" } })
          .then((r) => r.json())
          .then((j) => {
            const prods = (j.resources && j.resources.results && j.resources.results.products) || [];
            if (!prods.length) {
              results.innerHTML = '<p class="px-4 py-5 text-center text-[13px] text-ink/50">Nenhum produto encontrado.</p>';
            } else {
              results.innerHTML = prods.map((p) =>
                '<a href="' + p.url + '" class="flex items-center gap-3 px-4 py-2.5 transition hover:bg-sand/50">' +
                  '<span class="block h-12 w-12 shrink-0 overflow-hidden rounded-lg bg-sand/40">' +
                    (p.image ? '<img src="' + p.image + '" alt="" class="h-full w-full object-cover" loading="lazy">' : "") +
                  "</span>" +
                  '<span class="flex-1 text-[14px] font-medium leading-tight text-ink line-clamp-2">' + p.title + "</span>" +
                  (p.price ? '<span class="shrink-0 text-[13px] font-bold text-ink">' + fmtPrice(p.price) + "</span>" : "") +
                "</a>"
              ).join("") +
              '<a href="/search?q=' + encodeURIComponent(q) + '&type=product" class="block border-t border-ink/10 px-4 py-3 text-center text-[13px] font-semibold text-gold-600 transition hover:bg-sand/50">Ver todos os resultados</a>';
            }
            results.classList.remove("hidden");
          })
          .catch(() => clearResults());
      }, 250);
    });
  })();

  /* sincroniza contador no load */
  if (document.querySelector("[data-cart-count]")) refreshCart(false);
})();
